import { useParams } from 'react-router-dom'
import "./style.css"
import { DataKeys, Data1 } from "../../utils/Data";
import { Badge } from "react-bootstrap";

function ContentVideo() {
    const { contentName } = useParams()
    return (
        <section className="videos">
            <h2 className="videos-title">{Data1[contentName]?.title}</h2>
            <div className="videos-container">
                <iframe
                    width="800"
                    height="450"
                    src={Data1[contentName]?.videoLink}
                    title={Data1[contentName]?.title}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                ></iframe>
            </div>
            <div className="keys-container">
                {
                    DataKeys[contentName].map(datakey => {
                        return <Badge bg="primary" className="videos-keys-text" key={datakey}>{datakey}</Badge>
                    })
                }
            </div>
            <div>
                {Data1[contentName]?.game}
            </div>
        </section>
    )
}

export default ContentVideo